import { faChevronRight } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Breadcrumb, BreadcrumbProps } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

const CustomBreadcrumbStyled = styled.div`
  // background-color: var(--bg-content);
  display: inline-block;
  // padding: 5px 10px;
  // border-radius: 5px;
  // border: 1px solid var(--border-color);

  .ant-breadcrumb {
    li:last-child a {
      color: var(--color-black) !important;
    }
  }
`;

export default function CustomBreadcrumb({
  items = [],
  resetPadding = false,
}: BreadcrumbProps & { resetPadding?: boolean }) {
  const { t } = useTranslation();
  return (
    <CustomBreadcrumbStyled
      className={`${!resetPadding && 'px-[10px] py-[5px]'}`}
    >
      <Breadcrumb
        separator={
          <FontAwesomeIcon icon={faChevronRight} className="text-xs" />
        }
      >
        {items.map((e, index) => (
          <Breadcrumb.Item key={`${e?.href}-${index}`}>
            <NavLink to={e?.href}>
              {typeof e.title === 'string' ? t(e.title) : e.title}
            </NavLink>
          </Breadcrumb.Item>
        ))}
      </Breadcrumb>
    </CustomBreadcrumbStyled>
  );
}
